import { useParams } from 'react-router-dom';

import { ErrorBoundary } from 'common/components/withErrorBoundary';
import { routes, routeFor } from 'src/core/constants/routes';
import history from 'src/core/history';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

import { GraphQLProvider } from '../../components/GraphQLProvider';
import { PayablePanelContainer } from '../containers/PayablePanelContainer';
import { PayableTableContainer } from '../containers/PayableTableContainer';
import { PayablesFiltersContainer } from '../containers/PayablesFiltersContainer';
import { FiltersContextProvider } from '../containers/PayablesFiltersContainer/hooks';

// Validates that the ID only contains safe characters (alphanumeric, dashes, underscores)
// Prevents path traversal attacks (e.g., ../../other/path)
const isValidPayableId = (id: string | undefined): id is string => {
  if (!id) {
    return false;
  }
  return /^[\w-]+$/.test(id);
};

export const PayablesAllPage = () => {
  const { id: rawPayableId } = useParams() as { id?: string };
  const companyId = useCompanyId();

  // Sanitize payableId to prevent path traversal attacks
  const payableId = isValidPayableId(rawPayableId) ? rawPayableId : '';

  const goToPayable = (id: string = '') => {
    history.push(
      `${routeFor(`${routes.PAYABLES_ALL.path}`, { id, company: companyId })}${
        history.location.search
      }`,
    );
  };

  const panel = payableId && (
    <PayablePanelContainer
      payableId={payableId}
      onClose={() => goToPayable()}
    />
  );

  // @TODO: Not sure GraphQL is needed here, check if it can be removed
  return (
    <GraphQLProvider>
      <ErrorBoundary
        context={{ scope: 'all-payables', team: 'finance-accountant' }}
      >
        <div className="mb-24">
          <FiltersContextProvider>
            <div
              className="page__container mx-40"
              style={{ overflowY: 'unset' }}
            >
              <PayablesFiltersContainer />

              <PayableTableContainer
                payableId={payableId}
                onClick={goToPayable}
              />
              {panel}
            </div>
          </FiltersContextProvider>
        </div>
      </ErrorBoundary>
    </GraphQLProvider>
  );
};
